export const COUNTRY_SPAIN = "spain";
export const COUNTRY_UK = "united kingdom";
export const COUNTRY_POLAND = "poland";
export const COUNTRY_SWEDEN = "sweden";
export const COUNTRY_NORWAY = "norway";

export default {COUNTRY_SPAIN};
